export default __webpack_public_path__ + "scene5_1_bgae4d50.png";